const RUNNING_NUMBER_PAD = 4;

export function formatRunningNumber(value) {
  const num = Number.parseInt(String(value ?? ''), 10);
  if (!Number.isFinite(num) || num < 1) {
    return '0001';
  }
  return String(num).padStart(RUNNING_NUMBER_PAD, '0');
}

export function buildInvoiceNumber({ externalId, runningNumber }) {
  const ext = externalId ?? '';
  return `TRS-${ext}-${formatRunningNumber(runningNumber)}`;
}

export function parseRunningNumberFromInvoiceNumber(invoiceNumber) {
  if (!invoiceNumber) {
    return 1;
  }
  const parts = String(invoiceNumber).split('-');
  const last = parts[parts.length - 1];
  const parsed = Number.parseInt(last, 10);
  return Number.isFinite(parsed) && parsed >= 1 ? parsed : 1;
}

export function getNextRunningNumber(existingInvoiceNumbers = []) {
  if (!existingInvoiceNumbers.length) {
    return 1;
  }
  const max = existingInvoiceNumbers.reduce((acc, invoiceNumber) => {
    const running = parseRunningNumberFromInvoiceNumber(invoiceNumber);
    return running > acc ? running : acc;
  }, 0);
  return max + 1;
}
